export const deactivateActionTypes = {
    DEACTIVATE_START: "DEACTIVATE_START",
    DEACTIVATE_SUCCESS: "DEACTIVATE_SUCCESS",
    DEACTIVATE_FAILURE: "DEACTIVATE_FAILURE",
    SET_DEACTIVATED: "SET_DEACTIVATED",
    SET_IS_FAIL: "SET_IS_FAIL",
    REMOVE_DEACTIVATED: "REMOVE_DEACTIVATED"
}